import { getLearningObjectives } from 'app/crud/learningObjectives.crud';
import { put, select, takeLatest } from 'redux-saga/effects';
import { REDUCER_LEARNING_OBJECTIVES } from '../conf';
import { actionTypes as actionAuth } from './auth.duck';

export const actionTypes = {
  GetLearningObjectives: 'cms/GET_LEARNING_OBJECTIVES',
  SetLearningObjectives: 'cms/SET_LEARNING_OBJECTIVES',
  UpdateLearningObjectives: 'cms/UPDATE_LEARNING_OBJECTIVES',
};

const initialState = {
  data: [],
  loading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GetLearningObjectives:
      return { ...state, loading: true };

    case actionTypes.SetLearningObjectives: {
      const { response } = action.payload;
      if (response && response.status === 'success' && response.data) {
        return { data: response.data, loading: false };
      }
      return { ...state, loading: false };
    }

    case actionTypes.UpdateLearningObjectives: {
      const { objectives } = action.payload;
      return { data: objectives, loading: false };
    }

    case actionAuth.Logout:
      return initialState;

    default:
      return state;
  }
};

export const selectors = {
  getLearningObjectives: (state) => {
    return state.entities[REDUCER_LEARNING_OBJECTIVES].data;
  },
};

export const actions = {
  getLearningObjectives: (params) => ({ type: actionTypes.GetLearningObjectives, payload: { params } }),
  fulfillLearningObjectives: (response) => ({ type: actionTypes.SetLearningObjectives, payload: { response } }),
  updateLearningObjectives: (objectives) => ({ type: actionTypes.UpdateLearningObjectives, payload: { objectives } }),
};

function* getLearningObjectivesIfNeeded(action) {
  const objectives = yield select(selectors.getLearningObjectives);
  if (!objectives || objectives.length === 0 || action.payload?.isRefresh) {
    const { data } = yield getLearningObjectives(action.payload?.params);
    if (data && data.status === 'success') {
      yield put(actions.fulfillLearningObjectives(data));
    }
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GetLearningObjectives, getLearningObjectivesIfNeeded);
}
